var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar"},[_c('div',{class:[
          'calendar-header', 
          _vm.context === 'event-dates'? ['feathered-edges', 'bottom'] : '',
        ]},[_c('h3',{class:[
            'month-title',
            ,

          ]},[_vm._v(_vm._s(_vm.monthTitle))])]),_c('div',{staticClass:"calendar-grid"},[_vm._l((_vm.weekdays),function(day,index){return _c('div',{key:`weekday-${index}`,staticClass:"weekday"},[_vm._v(" "+_vm._s(day)+" ")])}),_vm._l((_vm.daysInMonth),function(day,index){return _c('div',{key:day.date || `empty-${index}`,class:['day', _vm.getDayClass(day)],on:{"click":function($event){return _vm.selectDate(day)}}},[_vm._v(" "+_vm._s(day.label)+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }